'use client';

import { FC } from 'react';
import { VideoPlayer } from 'molecules/VideoPlayer';
import { Product } from 'commerce/scayle/utils/adapter';
import { ProductVideoSlider } from './ProductVIdeoSlider';
import styles from './styles.module.css';

export const ProductVideoBlock: FC<{ videos: Product['video'] }> = ({
  videos,
}) => {
  return videos.length === 1 ? (
    <div className={styles.videoWrapper}>
      <VideoPlayer url={videos[0]} />
    </div>
  ) : (
    <ProductVideoSlider videos={videos} />
  );
};
